import styled from 'styled-components'
import {
  GridProps,
  height,
  HeightProps,
  width,
  WidthProps,
} from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string) =>
  !['gridTemplateColumns'].includes(prop)

export const Container = styled.div.withConfig({ shouldForwardProp })<
  GridProps & GapProps & HeightProps
>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  background-color: ${themeGet('colors.background.screenAlt')};

  @media screen and (min-width: ${themeGet('breakpoints.4')}) {
    border-top-left-radius: 16px;
    width: 50%;
  }

  ${height}
`

export const Content = styled.div<WidthProps & HeightProps>`
  display: flex;
  align-items: center;
  min-height: 100%;

  ${width}
  ${height}
`
